import { CollectionPoint } from 'types/location';
import * as yup from 'yup';

export const getInitialValues = (point: CollectionPoint | null) => ({
  name: point?.name || '',
  type: point?.type || '',
  site: point?.site || '',
  address: point?.address || {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: '',
  },
  code: point?.code || '',
  pickupFrequency: point?.pickupFrequency || '',
  pickupDayOfTheWeek: point?.pickupDayOfTheWeek || [],
  deliveryInstructions: point?.deliveryInstructions || '',
});

export const validationSchema = yup.object().shape({
  name: yup.string().required('Name is a required field'),
  type: yup.string(),
  site: yup.string(),
  address: yup
    .object()
    .shape({
      addressLine1: yup.string().required(),
      // The unit (ClickUp 86bcgvh8k): most addresses have none, so it can't
      // be required, or picking a new address would block saving.
      addressLine2: yup.string(),
      city: yup.string().required(),
      state: yup.string().required(),
      zip: yup.string().required('Zip code is a required field'),
    })
    .required('Address is a required field'),
  pickupFrequency: yup
    .string()
    .required('Pickup Frequency is a required field'),
  pickupDayOfTheWeek: yup.array(),
  deliveryInstructions: yup.string(),
});
